// ترجماتُ المجموعة 10 — نصوصُ الخادم في سجلّ النشاط (`audit_logs.details`): تسمياتُ
// «قبل ← بعد» وقيمُها المعدودة، تُترجَم عند الرسم لأنّ الصفوف القديمة مخزَّنةٌ عربيّة.
const EN_B10: Record<string, string> = {
  "حالة رفعة تسليم": "Handover upload status",
  "حالة رفعة استلام": "Return upload status",
  "حالة الرفعة": "Upload status",
  "عمولة الرافع": "Uploader commission",
  "تُصرف": "Payable",
  "دُمجت محادثةُ": "Conversation merged",
  "أُعيدت محادثاتٌ": "Conversations restored",
  "{c} محادثة · {m} رسالة": "{c} conversations · {m} messages",
  "حالة السند": "Receipt status",
  "سارٍ": "Valid",
  "عداد آخر صيانة": "Last service odometer",
  "اسم العميل الحالي": "Current customer name",
  "هاتف العميل الحالي": "Current customer phone",
  "النشاط": "Business",
  "شرائح الأسعار": "Price tiers",
  "انتهاء الاستمارة": "Registration expiry",
  "رقم الشاصي": "Chassis no.",
  "المواصفات": "Features",
  "وسائط السيارة": "Car media",
  "فيديو جديد": "New video",
  "صورة جديدة": "New photo",
  "محذوفة": "Deleted",
  "موجود": "Exists",
  "غير موجود": "None",
  "تم الإنشاء": "Created",
  "بداية الحجز": "Booking start",
  "نهاية الحجز": "Booking end",
  "عدد الساعات": "Hours",
  "إجمالي السعر": "Total price",
  "موقع التسليم": "Drop-off location",
  "حالة الحجز": "Booking status",
  "حالة الدفع": "Payment status",
  "متابعةٌ منجَزة": "Follow-up done",
  "متابعة حتى": "Follow up until",
  "يوم السداد": "Payment day",
  "نمط الجدولة": "Scheduling mode",
  "قضيّة قانونيّة": "Legal case",
  "تاريخ القانونيّة": "Legal date",
  "ملاحظة القانونيّة": "Legal note",
  "هدف الشهر": "Monthly target",
  "مستبعَد من الكشف": "Excluded from statement",
  "في كشف الشهر": "In this month's statement",
  "موعد هذا الشهر": "This month's appointment",
  "سبب الموعد": "Appointment reason",
  "يوم صرف الجهة": "Employer pay day",
  "الاسم القانوني": "Legal name",
  "الرمز المختصر": "Short mark",
  "تاريخ العقد": "Contract date",
  "اسم المؤجّر": "Lessor name",
  "عنوان المؤجّر": "Lessor address",
  "ممثّل المؤجّر": "Lessor representative",
  "سجل المؤجّر التجاري": "Lessor commercial registration",
  "هاتف المؤجّر": "Lessor phone",
  "اسم المستأجر": "Lessee name",
  "عنوان المستأجر": "Lessee address",
  "ممثّل المستأجر": "Lessee representative",
  "سجل المستأجر التجاري": "Lessee commercial registration",
  "هاتف المستأجر": "Lessee phone",
  "المدّة (أيام)": "Term (days)",
  "المدّة (أشهر)": "Term (months)",
  "المدّة (سنوات)": "Term (years)",
  "مهلة إخطار التجديد": "Renewal notice period",
  "قيمة الإيجار الإجمالية": "Total rent",
  "الإيجار اليومي": "Daily rent",
  "الإيجار الأسبوعي": "Weekly rent",
  "الإيجار الشهري": "Monthly rent",
  "العملة": "Currency",
  "دورة الدفع": "Payment cycle",
  "مبلغ التأمين": "Deposit amount",
  "قيمة الصيانة والإصلاح": "Maintenance & repair fee",
  "قيمة الجهاز عند الحادث": "Device value in an incident",
  "عدد الأجهزة": "Device count",
  "حالة العقد": "Contract status",
  "الرقم المدني للمؤجّر": "Lessor civil ID",
  "الرقم المدني للمستأجر": "Lessee civil ID",
  "تاريخ التوقيع": "Signing date",
  "النسخة الموقّعة": "Signed copy",
  "منتهٍ": "Ended",
  "رقم الصنف / الباركود": "Item no. / barcode",
  "الملاحظات": "Notes",
  "مدة التنبيه": "Reminder period",
  "صورة الورقة": "Document image",
  "مدة التذكير": "Reminder period",
  "منجزة (تلقائياً)": "Done (automatically)",
  "تجديد تأمين ضدّ الغير": "Third-party insurance renewal",
  "تجديد تأمين شامل": "Comprehensive insurance renewal",
  "مخالفات / تنفيذ أحكام مرور": "Traffic fines / judgments",
  "فحص فنّي": "Technical inspection",
  "معاملة أخرى": "Other errand",
  "انتهاء الدفتر": "Registration expiry",
  "انتهاء التأمين ضد الغير": "Third-party insurance expiry",
  "انتهاء التأمين الشامل": "Comprehensive insurance expiry",
  "التنبيه مفعّل": "Alert enabled",
  "أيام التنبيه قبل السحب": "Alert days before due date",
  "إرسال التنبيه إلى": "Send alert to",
  "يحتاج عقداً": "Needs a contract",
  "المسدَّد من القرض": "Loan paid",
  "بداية الأقساط": "Installments start",
  "نهاية الأقساط": "Installments end",
  "سعر سوقيّ منخفض": "Market price (low)",
  "سعر سوقيّ مرتفع": "Market price (high)",
  "مستبعَدة من القرار": "Excluded from decision",
  "سبب الاستبعاد": "Exclusion reason",
  "نسبة جاهزية القرض": "Loan readiness %",
  "أرضيّة جاهزية القرض": "Loan readiness floor",
  "تحذير الصيانة": "Maintenance warning",
  "خروج الصيانة": "Maintenance exit",
  "تحذير الصافي": "Net warning",
  "خروج الصافي": "Net exit",
  "حدّ العمر (سنوات)": "Age limit (years)",
  "هامش Core": "Core margin",
  "هامش Stabilizer": "Stabilizer margin",
  "هامش Tactical": "Tactical margin",
  "حدّ Core": "Core threshold",
  "حدّ Stabilizer": "Stabilizer threshold",
  "حدّ Tactical": "Tactical threshold",
  "تاريخ التقييم": "Valuation date",
  "مصدر التقييم": "Valuation source",
  "نافذة الحداثة (أشهر)": "Recency window (months)",
  "أدنى تاريخ (أشهر)": "Minimum history (months)",
  "أدنى عدد عقود": "Minimum contracts",
  "هامش ExitCandidate": "ExitCandidate margin",
  "تسارع الصيانة": "Maintenance acceleration",
  "انحدار القبض": "Collections decline",
  "تحذير المتأخّرات": "Arrears warning",
  "سبب قرار الإدارة": "Management decision reason",
  "مزامنة Drive8": "Drive8 sync",
};
export default EN_B10;
